<template>
    <history-table>
        <template #columns>
            <th>Date</th>
            <th>Custodian</th>
            <th>Status</th>
            <th></th>
        </template>

        <property-table-row
            v-for="entry in data.entries"
            :key="entry.id"
            :data="data"
            :entry="entry"
        />
    </history-table>
</template>

<script>
import HistoryTable from '../HistoryTable.vue';
import PropertyTableRow from './PropertyTableRow.vue';

export default {
    components: { HistoryTable, PropertyTableRow },
    props: {
        data: Object,
    },
    data() {
        return {};
    },
    created() {},
    methods: {},
};
</script>
